import classNames from 'classnames';
import React from 'react';
import { toTitleCase } from '../../../Lib/String';
import { withInjectedProps } from '../../Core/InjectedPropsContext';
import './SectionGroup.scss';

interface ISectionGroupProps {
  heading?: string;
  visible?: boolean;
}

const SectionGroupBase: React.FC<React.PropsWithChildren<ISectionGroupProps>> = ({
  children,
  heading,
  visible = true,
}) => {
  if (heading) heading = toTitleCase(heading);

  if (!visible) return null;

  return (
    <section className={classNames('SectionGroup')}>
      {heading && <h2 className="SectionGroup-Heading">{heading}</h2>}
      {children && <div className="SectionGroup-Content">{children}</div>}
    </section>
  );
};

/**
 * Groups sections under a parent section.
 * This allows us to provide a shared heading and to identify related fields using the DOM element hierarchy.
 */
const SectionGroup = withInjectedProps(SectionGroupBase);

export { SectionGroup };
export default SectionGroup;
